import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "o-container -full" }
const _hoisted_2 = { class: "c-grid-cars__wrap" }
const _hoisted_3 = { class: "c-grid-cars" }
const _hoisted_4 = { class: "u-text-center c-grid-cars-back-to-top" }
const _hoisted_5 = { href: "#haut-de-page" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Controls = _resolveComponent("Controls")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Card = _resolveComponent("Card")
  const _component_Pager = _resolveComponent("Pager")
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["c-section-grid-cars", {'-grid-cars-sidebar-active': _ctx.$root.sidebarActive}]),
    id: "haut-de-page"
  }, [
    _createVNode(_component_Controls),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Sidebar, {
          filters: _ctx.$root.filters
        }, null, 8 /* PROPS */, ["filters"]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$root.items, (car, i) => {
            return (_openBlock(), _createBlock(_component_Card, {
              type: "small",
              key: car.id,
              car: car,
              i: i
            }, null, 8 /* PROPS */, ["car", "i"]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_ctx.$root.featured)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                type: "big",
                car: _ctx.$root.featured,
                i: 33
              }, null, 8 /* PROPS */, ["car"]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createVNode(_component_Pager),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", _hoisted_5, [
          _cache[0] || (_cache[0] = _createTextVNode("Retour ")),
          _createVNode(_component_svgIco, { icon: "arrow-up" })
        ])
      ])
    ])
  ], 2 /* CLASS */))
}